import { BookDamagedGlassV2 } from './book-free-slots-ws-v2';

export interface RequestAppointmentWsV2Params {
  mobileServices?: {
    /** Si Pose à Dom demandée */
    address: string;
    postalCode: string;
    city: string;
    comment?: string;
  };
  partnerBranch?: {
    /** N° FCE AXA unique du centre */
    id: string;
  };
  /** 1 pour prêt de véhicule, 0 sans */
  share?: 1 | 0;
  damage?: BookDamagedGlassV2;
  vehicle?: {
    /** Code VIN du véhicule */
    vin?: string;
    /** Immatriculation du véhicule */
    vrn: string;
    /** Marque du véhicule */
    manufacturer?: string;
    /** Modèle du véhicule */
    model?: string;
    /** Année de première mise en service */
    year?: number;
    /** type de vehicule (0: Not set, 1: Private, 2: Company, 3: Lease, 4: Rental) */
    ownerType?: number;
  };
  insured: {
    /** Nom de l'assuré */
    lastname: string;
    /** Prénom de l'assuré */
    firstname: string;
    /** Email de l'assuré */
    email: string;
    /** N° de téléphone */
    phoneNumber: string;
    /** Preference de notification */
    preferedNotifcationType?: 'Email' | 'SMS' | 'WhatsApp';
  };
  policyInformation?: {
    insuranceChoice: string;
    /** Nom de l'assureur */
    insuranceName: string;
    insuranceCode: string;
    /** N° de contrat de l'assuré */
    policyNumber?: string;
    /** Date de début du contrat */
    insuranceStartDate?: Date;
    /** Date de fin du contrat */
    insuranceEndDate?: Date;
    /** true si l'assuré est couvert BDG, sinon false */
    isCovered?: boolean;
    /** Franchise si remplacement */
    replacementDeductible?: number;
    /** Franchise si réparation */
    repairDeductible?: number;
    /** Taux de franchise si remplacement */
    replacementRateDeductible?: number;
    /** Taux de franchise si réparation */
    repairRateDeductible?: number;
    /** Franchise remplacement minimum */
    minReplacementDeductible?: number;
    /** Franchise remplacement maximum */
    maxReplacementDeductible?: number;
    /** Franchise de réparation minimum */
    minRepairDeductible?: number;
    /** Franchise de réparation maximum */
    maxRepairDeductible?: number;
    /** Plafond franchise remplacement */
    replacementGuaranteeCeiling?: number;
    /** Plafond franchise réparation */
    repairGuaranteeCeiling?: number;
  };
  /** Référence du dossier */
  folderRef: string;
  /** Commentaire */
  comments?: string;
  /** Notification **/
  notification?: boolean;
}

export interface RequestV2Params {
  mobileServices?: {
    /** Si Pose à Dom demandée */
    address: string;
    postalCode: string;
    city: string;
    comment?: string;
  };
  partnerBranch?: {
    /** N° FCE AXA unique du centre */
    id: string;
  };
}

export interface RequestAppointmentWsV2ResponseSuccess {
  status: 'OK';
  response: {
    code: '201';
    message: 'Created';
  };
  data: {
    folderID: string;
  };
  request?: any; // Only used to send data to email admin
}

export interface RequestAppointmentWsV2ResponseError {
  status: 'ERROR';
  response: {
    code: '500';
    message: 'Error';
  };
}
